import type { TextProps } from '@wartek-id/text-v1'
import { Text } from '@wartek-id/text-v1'

export const TextLabel = ({
  children,
  ...props
}: TextProps & { children: any }) => (
  <Text variant="heading-sm" {...props}>
    {children}
  </Text>
)

export const TextValue = ({ children, ...props }) => (
  <Text variant="body" className="text-black" {...props}>
    {children}
  </Text>
)
